import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { useGetFixSession, useGetFixSessionCreds } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import { Card, CardContent } from '@/components/card'
import IconButton from '@/components/iconButton'

interface Props {
    clientCode: string
    sessionId: string
}

export default function FixSessionDetails({ clientCode, sessionId }: Props) {
    const session = useGetFixSession(clientCode, sessionId, { query: { suspense: true } })

    if (!session.data) {
        return <UnexpectedDataStateError />
    }

    return (
        <div className="grid grid-cols-4 gap-4 mb-4">
            <Card>
                <CardContent className="pt-6">
                    <h3>SenderCompId</h3>
                    <h5>{session.data.senderCompId}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>TargetCompId</h3>
                    <h5>{session.data.targetCompId}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>BeginString</h3>
                    <h5>{session.data.beginString}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>DefaultAppVerId</h3>
                    <h5>{session.data.defaultAppVerId}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>TransportDataDictionary</h3>
                    <h5>{session.data.transportDataDictionary}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>AppDataDictionary</h3>
                    <h5>{session.data.defaultAppVerId}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>Username</h3>
                    <h5>{session.data.username}</h5>
                </CardContent>
            </Card>
            <PasswordCard clientCode={clientCode} sessionId={sessionId} />
        </div>
    )
}

const DefaultPassword = '************'

function PasswordCard({ clientCode, sessionId }: Props) {
    const [password, setPassword] = useState(DefaultPassword)

    const handleShowPassword = () => {
        setPassword('password')
    }
    const handleHidePassword = () => {
        setPassword(DefaultPassword)
    }

    const onClick = password === DefaultPassword ? handleShowPassword : handleHidePassword

    const Icon = password === DefaultPassword ? Eye : EyeOff
    const tooltipText = password === DefaultPassword ? 'Show password' : 'Hide password'
    const text =
        password === DefaultPassword ? password : <PasswordText clientCode={clientCode} sessionId={sessionId} />

    return (
        <Card>
            <CardContent className="pt-6">
                <h3>Password</h3>
                <div className="flex items-center">
                    <div className="flex-grow">
                        <h5>{text}</h5>
                    </div>
                    <div>
                        <IconButton icon={Icon} tooltip={tooltipText} onClick={onClick} />
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

function PasswordText({ clientCode, sessionId }: Props) {
    const { data: creds } = useGetFixSessionCreds(clientCode, sessionId)

    return creds?.password
}
